// Helpers for locale-keyed content. `en`/`de` are optional so a page or
// profile can ship Danish first and gain translations later (phased rollout);
// the accessors fall back to Danish until a translation exists.

import { type Locale } from "./config";

export type LocalizedText = { da: string } & Partial<Record<Locale, string>>;
export type LocalizedList = { da: string[] } & Partial<Record<Locale, string[]>>;

export function tx(t: LocalizedText, locale: Locale): string {
  return t[locale] ?? t.da;
}

export function tl(l: LocalizedList, locale: Locale): string[] {
  return l[locale] ?? l.da;
}
